var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb'),_c('PostList',{attrs:{"category":"BBPP Productos y Servicios - Créditos"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }